import SideNav from "./SideNav";
import TopBar from "./TopBar";
import { useState, useEffect, useContext } from "react";
import Swal from 'sweetalert2';
import axios from 'axios';
import {Link, useParams, useNavigate} from "react-router-dom";
import ReactPaginate from 'react-paginate';
import UserContext from './UserContext';

function EditSettingPromoCode(){

    const API_URL = process.env.REACT_APP_API_URL;
    const { id } = useParams();
    const navigate = useNavigate();
    const [game_available_location, setGame_available_location] = useState([]);
    const [promo_code_by_id, setPromo_code_by_id] = useState([]);
    const [error_list, setErrorList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const userContext = useContext(UserContext);
    const [isLocationLoading, setIsLocationLoading] = useState(false);

   
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [loading, setLoading] = useState(false);
    const [games, setGames] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [promoCodelist, setPromoCodeList] = useState([]);
   const [selectedPackageType, setSelectedPackageType] = useState([
  "laser_tag_package",
  "birthday_package",
  "corporate_event",
]);

   const filteredResult = promoCodelist.filter(item =>
  item.code_name.toLowerCase().includes(searchQuery.toLowerCase())
);


const packageTypeLabels = {
  laser_tag_package: "Laser Tag",
  birthday_package: "Birthday",
  corporate_event: "Corporate"
};


    const handlePageChange = (selectedPage) => {
      setCurrentPage(selectedPage.selected);
    };
  
    
      const handleLocationChange = (e) => {
        const value = parseInt(e.target.value, 10);
        let updatedLocations = selectedLocations; // Ensure it's an array
      
        if (e.target.checked) {
          updatedLocations = [...updatedLocations, value];
        } else {
          updatedLocations = updatedLocations.filter((id) => id !== value);
        }
      
        setSelectedLocations(updatedLocations); // Convert back to a comma-separated string
     setPromo_code_by_id((prev) => ({
    ...prev,
    applicable_locations: updatedLocations.join(','),
  }));

     
      };

        const handlePackageChange = (e) => {
      const value = e.target.value; 
    
        let updatedPackages = selectedPackageType;

        if (e.target.checked) {
          updatedPackages = [...updatedPackages, value];
        } else {
          updatedPackages = updatedPackages.filter((id) => id !== value);
        }
      
        setSelectedPackageType(updatedPackages); // Convert back to a comma-separated string
   
    setPromo_code_by_id((prev) => ({
    ...prev,
    applicable_game_packages: updatedPackages.join(','),
  }));
      };

     

const handleInput = (e) => {
  const { name, value } = e.target;
  setPromo_code_by_id((prev) => ({
    ...prev,
    [name]: name === "is_percentage" ? parseInt(value) : value,
  }));
};

    const fetchGames = async () => {
        try {
          const response = await axios.get(`${API_URL}/view-game`);
          setGames(response.data.game);
        } catch (error) {
          console.error("Error fetching games:", error);
        }
      };
    
      const fetchLocations = async () => {
        try {
         
          const response = await axios.get(`${API_URL}/view-game-location`);
          setLocations(response.data.gameLocation);
        } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };
    



    useEffect(() => {
        
        // const inventory_id = props.match.params.id;
        setIsLoading(true);
    
         axios.get(`${API_URL}/edit-promo-code/`+id, ).then(res=>{
           
            if(res.data.status === 200){
                setPromo_code_by_id(res.data.promoCode);
                setSelectedLocations(res.data.promoCode.applicable_locations.split(',').map(Number));
                setSelectedPackageType(res.data.promoCode.applicable_game_packages.split(','));
            }
            else if(res.data.status === 404){
          // Swal("Error",res.data.error,"error");
              //navigate.push('/view-inventory');
              console.log(res.data.error)
            }
            fetchLocations();
            getPromoCodeList(); 
          
         });
         

        }, []);



function editPromoCode(promo_code_id){
    setErrorList([]);
        axios.get(`${API_URL}/edit-promo-code/`+promo_code_id, ).then(res=>{
           
        if(res.data.status === 200){
            setPromo_code_by_id(res.data.promoCode);
           setSelectedLocations(res.data.promoCode.applicable_locations);
           
        }
        else if(res.data.status === 404){
       Swal("Error",res.data.error,"error");
          //navigate.push('/view-inventory');
          console.log(res.data.error)
        }
   
      
     });
     getPromoCodeList();

    }


    
    
  
         function getPromoCodeList()
        {
          
          axios.get(`${API_URL}/view-promo-code`).then(res=>{
              if(res.data.status === 200){
                  setPromoCodeList(res.data.promoCode); 
                
              }     
              else if(res.data.status === 404){
                  setPromoCodeList([]);
                  }
                  setIsLoading(false);
           });  
         
        }
    
          async function update(event)
          {
           event.preventDefault();
           setLoading(true);
              
           const formData = new FormData();

           const data = promo_code_by_id;
           
               await axios.post(`${API_URL}/update-promo-code/` +id ,data).then(res =>{
   
    
        Swal.fire({
                  icon:"success",
                  text:res.data.message
                }).then(function(){
                    setLoading(false);
                    setErrorList([]);
                    navigate('/setting-promo-code');
                
              });
              }).catch(function(error) {
                setLoading(false);
                 // if(error.response.status===422){         
                 setErrorList(error.response.data.validate_err);
                 // }
             //    else{
                  Swal.fire({
                    text:error.response.data.message,
                    icon:"error"
                  })
             //    }
              })
           
              }

       

              const deletePromoCode= (e,id) =>{
            e.preventDefault();
            var buttonClicked = window.confirm("Are you sure you want to delete this promo code?");
            if(buttonClicked == true){
               // const thisClicked = e.currentTarget;
               // thisClicked.innerText = "Deleting";
                axios.delete(`${API_URL}/delete-promo-code/`+id).then(res => {
                 
              Swal.fire({
                      icon:"success",
                      text:res.data.message
                    }).then(function(){
                       // thisClicked.closest("tr").remove();  
                        
                  });
                  getPromoCodeList();
                })
            }
            else
            {
                getPromoCodeList();
            }
           
           }

           
    return(
        <div>
 <SideNav/>
            <TopBar/>

            {isLoading?
      <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}

            <div class="right_panel position contact_section vh-100" id="right_panel">

<div class="main_title d-flex align-items-center">
    <h1><i class="bi bi-sticky"></i> Promo Code</h1>
</div>

<div class="content_wrapper pt-0">
    <div class="vm_content_box_1">
        <div class="title">
            <h2>Edit Promo Code</h2>
        </div>
        <div class="content pt-3">  
                      
                      <div class="content pt-4 pb-4">
                            <div class="row">
                       <div class="col-md-4">
                            <div class="form-group">
                            <label for="game">Code Name</label>
                            <input type="text" class="form-control" name="code_name" id="code_name" placeholder="Enter Code Name" value={promo_code_by_id.code_name} 
                                     onChange={handleInput } />
                                       <span class="text-danger">{error_list.code_name}</span>
                                </div>
                                </div>

                                <div class="col-md-4">
                            <div class="form-group">
                            <label for="game">Active From</label>
                            <input type="date" class="form-control" name="active_from" id="active_from"  value={promo_code_by_id.active_from} 
                                       onChange={handleInput } />
                                       <span class="text-danger">{error_list.active_from}</span>
                                </div>
                                </div>


                                <div class="col-md-4">
                            <div class="form-group">
                            <label for="game">Active To</label>
                            <input type="date" class="form-control" name="active_to" id="active_to"  value={promo_code_by_id.active_to} 
                                      onChange={handleInput } />
                                       <span class="text-danger">{error_list.active_to}</span>
                                </div>
                                </div>

                                <div class="col-md-4">
                            <div class="form-group">
                            <label>Is Percentage</label>
                            <select   className="form-select" name="is_percentage" value={promo_code_by_id.is_percentage}  onChange={handleInput } >
          <option value={1}>Yes</option>
          <option value={0}>No</option>
        </select>
                                       <span class="text-danger">{error_list.is_percentage}</span>
                                </div>
                                </div>

                               

    
               <div class="col-md-4">
                            <div class="form-group">
        <label>Value Amount</label>
        <input type="text" name="value_amount" className="form-control" value={promo_code_by_id.value_amount}    onChange={handleInput }  />
      </div>
      </div>

      <div class="col-md-4">
      <div class="form-group">
        <label>Usable Count</label>
        <input type="number" name="usable_count" className="form-control" value={promo_code_by_id.usable_count}    onChange={handleInput } />
      </div>
      </div>


                                
                                <div className="col-md-4">
                                <label>Select Locations:</label>
                                <div class="px-3 mb-1 bg-light mt-1 pb-3 pt-3">
        
<div>{isLocationLoading? <p>Loading...</p> :


                            <div class="row ">
        {locations.map((location) => (
            <div className="col-md-8 pb-2" key={location.id}>
      <div className="form-group-checkbox d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
        
            <input
             style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
              type="checkbox"
              id={`location-${location.id}`}
              value={location.id}
               onChange={handleLocationChange}
              checked={selectedLocations.includes(location.id)}
            />
            <label htmlFor={`location-${location.id}`}>{location.location_name}</label>
          </div>
          </div>
          </div>
                         
        ))}
                                </div>
}

</div>


                                </div>
                                <span class="text-danger">{error_list.location_id}</span>
                            </div>


<div className="col-md-4">
                              <label>Select Package Type:</label>
                                <div class="px-3 mb-1 bg-light mt-1 pb-3 pt-3">
        

                            <div class="row ">
         {[
        { label: "Laser Tag Package", value: "laser_tag_package" },
        { label: "Birthday Package", value: "birthday_package" },
        { label: "Corporate Event", value: "corporate_event" },
      ].map((option) => (
            <div className="col-md-8 pb-2" key={option.value}>
      <div className="form-group-checkbox d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
        
            <input
             style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
              type="checkbox"
                id={`package-type-${option.value}`}
                value={option.value}
              onChange={handlePackageChange}
              checked={selectedPackageType.includes(option.value)}
            />
     <label htmlFor={`package-type-${option.value}`} >{option.label} </label>
          </div>
          </div>
          </div>
                         
        ))}
                                </div>





                                </div>
                                <span class="text-danger">{error_list.location_id}</span>
                            </div>




                            </div>
                           
              


                                       
                         
                    <button onClick={update} class="btn btn-sm btn_secondary text-white"><i class="bi bi-save me-2"></i> {loading?"Saving":"Save"}</button>
                            
                            </div>

                           
                            
                    
            
        </div>
    </div>
<div class="vm_content_box_1 mt-4">
        <div class="title">
            <h2>Manage Promo Code</h2>
        </div>

        <div class="content">
        <div class="row pt-3">
                          
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                              
                   
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search code name" type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>

                         
                            <>
                            <div class="table-responsive">
                            <table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                          <th>Code Name</th>
                                          <th>Active From</th>
                                          <th>Active To</th>
                                          <th>Percentage</th>
                                          <th>Value amount</th>
                                          <th>Usable_count</th>
                                          <th>Used count</th>
                                          <th>Booking Id</th>
                                          <th>Locations</th>
                                             <th>Game Packages</th>
                                            <th class="text-end">Action</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                    {filteredResult.length === 0 ? (
        <tr>
          <td colSpan="4" style={{ textAlign: "center", verticalAlign: "middle" }}>
            <p className="odd" style={{ margin: 0 }}>No records found</p>
          </td>
        </tr>
      ) : (

                                        filteredResult.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => 
                                            {
const locationIds = (item.applicable_locations || '')
  .split(',')
  .map(id => parseInt(id.trim()));

const locationNames = locations
  .filter(location => locationIds.includes(location.id))
  .map(location => location.location_name)
  .join(', ');
                                              return (
                                           <tr key={index}>
                              <td><p>{item.code_name}</p></td>     
                              <td><p>{item.active_from}</p></td>   
                              <td><p>{item.active_to}</p></td>             
                              <td><p>{item.is_percentage === 1 ? "Yes" : "No"}</p></td> 
                              <td><p>{item.value_amount}</p></td>   
                              <td><p>{item.usable_count}</p></td>   
                               <td><p>{item.used_count}</p></td> 
                               <td>
                               {item.booking_ref_ids.map((booking, i) => (
                                 <span key={i}>
                                   <Link to={`/booking-details/${booking.id}`} style={{ marginRight: "5px" }}>
                                     {booking.booking_ref_id}
                                   </Link>
                                   {i < item.booking_ref_ids.length - 1 ? ', ' : ''}
                                 </span>
                               ))}
                             </td>
                             
                              <td><p>{locationNames}</p></td>
                              <td>
  {(item.applicable_game_packages || '').split(',') .map((pkg) => packageTypeLabels[pkg.trim()])
    .filter(Boolean)
    .join(', ')}
</td>

                                                <td class="d-flex justify-content-end">

                                                    <Link to={`/edit-promo-code/${item.id}`} class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre">
                                                        <i class="bi bi-pencil-square"></i> Edit</Link>

                                                    <button class="btn btn-sm btn_secondary" style={{ background: "red", color: "white", margin: "0px 0px 0px 10px" }}
                                                        onClick={(e) => deletePromoCode(e, item.id)}><i class="bi bi-trash3"></i> Delete</button>
                                                </td>
                                            </tr>


);
}))}
                                    </tbody>
                                    <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
</tfoot>
                                    {/* <tfoot>
                                        <tr>
                                        <th>Game Name</th>
                                        <th>Locations</th>
                                            <th class="text-end">Action</th>
                                        </tr>
                                    </tfoot> */}
                                </table>
                                </div>
                                <div class="col-md-3" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                        {filteredResult.length > 0 && `Showing 1 to ${Math.min(perPage, filteredResult.length)} of ${filteredResult.length} entries`}
                                    </div><div class="col-md-9" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredResult.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div></>
                      

        </div>
    </div>
</div>

</div>

        </div>
    )
}
export default EditSettingPromoCode;